export default "__VITE_ASSET__VmzdRBcT__"